import { render, staticRenderFns } from "./fromList.vue?vue&type=template&id=560c4292&"
import script from "./fromList.vue?vue&type=script&lang=js&"
export * from "./fromList.vue?vue&type=script&lang=js&"
import style0 from "./fromList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports